export default __webpack_public_path__ + "static/char-thumb-57-84218275eaa8e4696eb9743a95c9b77c.webp";